const axios = require('axios');
export class NHLAPI {
    constructor(version = 1) {
        this.url = (endpoint) => {
            return this.api[this.version].url + '/' + endpoint;
        };
        this.teams = () => {
            return axios.get(this.url('teams'));
        };
        this.team = (id) => {
            return axios.get(this.url('teams/' + id));
        };
        this.roster = (id) => {
            return axios.get(this.url('teams/' + id + '/roster'));
        };
        this.player = (id) => {
            return axios.get(this.url('people/' + id));
        };
        this.playerStats = (id) => {
            return axios.get(this.url('people/' + id + '?hydrate=stats(splits=statsSingleSeason)'));
        };
        this.playerProfileImage = (id) => {
            return "https://nhl.bamcontent.com/images/headshots/current/168x168/" + id + ".png";
        };
        this.playerProfileImageSmall = (id) => {
            return "https://nhl.bamcontent.com/images/headshots/current/60x60/" + id + ".png";
        };
        this.playerActionShotImage = (id) => {
            return "https://nhl.bamcontent.com/images/actionshots/" + id + ".jpg";
        };
        this.playerActionShotImageLow = (id) => {
            return "https://nhl.bamcontent.com/images/actionshots/" + id + "_low_resolution.jpg";
        };
        this.version = version;
        this.api = {
            '1': {
                url: 'https://statsapi.web.nhl.com/api/v1'
            }
        };
    }
}
//# sourceMappingURL=NHLAPI.js.map


// WEBPACK FOOTER //
// ./src/modules/NHLAPI.js